export const LoggingConfig = {
  dataDog: {
    clientToken: "pub9d080fa927b4a147912b45a6c3ebff00",
    site: "datadoghq.eu",
    forwardErrorsToLogs: true,
    forwardConsoleLogs: "all",
    sessionSampleRate: 100,
  },
};
